<template>
  <el-dialog
    custom-class="event-activity-dialog"
    :visible="dialogVisible"
    width="45%"
    :show-close="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    @close="handleClose"
  >
    <button type="button" class="event-activity-dialog__close" aria-label="close" @click="handleClose">
      <i class="el-icon-close" />
    </button>
    <div class="event-activity-dialog__body">
      <div class="event-activity-dialog__icon">
        <i class="el-icon-message-solid" />
      </div>
      <div v-if="title" class="event-activity-dialog__title">{{ title }}</div>
      <div v-if="dateText" class="event-activity-dialog__date">
        <i class="el-icon-date" />
        <span>{{ dateText }}</span>
      </div>
      <div v-if="descriptionLines.length || image" class="event-activity-dialog__scroll">
        <div v-if="descriptionLines.length" class="event-activity-dialog__desc">
          <p v-for="(line, index) in descriptionLines" :key="index">{{ line }}</p>
          <p>{{ $t('可在左侧【活动】栏中查看券使用情况与资金流向') }}</p>
        </div>
        <div v-if="image" class="event-activity-dialog__image">
          <el-image :src="image" :preview-src-list="[image]" fit="contain" />
        </div>
      </div>
      <el-button class="event-activity-dialog__confirm" type="primary" @click="handleConfirm">
        {{ confirmText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'EventActivityDialog',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      /** 主标题，由父组件传入 */
      title: {
        type: String,
        default: '',
      },
      /** 活动时间文案，由父组件传入 */
      dateText: {
        type: String,
        default: '',
      },
      /** 说明文案：字符串（可用 \\n 换行）或字符串数组，由父组件传入 */
      description: {
        type: [String, Array],
        default: '',
      },
      /** 活动图片 URL，空则不展示 */
      image: {
        type: String,
        default: '',
      },
      confirmText: {
        type: String,
        default: '我知道了',
      },
    },
    data() {
      return {
        innerVisible: false,
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.innerVisible
        },
        set(val) {
          this.innerVisible = val
          this.$emit('update:visible', val)
        },
      },
      descriptionLines() {
        if (Array.isArray(this.description)) {
          return this.description.filter((line) => line != null && String(line).trim() !== '')
        }
        if (typeof this.description === 'string' && this.description.trim()) {
          return this.description.split('\n').filter((line) => line.trim() !== '')
        }
        return []
      },
    },
    watch: {
      visible: {
        immediate: true,
        handler(val) {
          this.innerVisible = val
        },
      },
    },
    methods: {
      show() {
        this.innerVisible = true
        this.$emit('update:visible', true)
      },
      close() {
        this.handleClose()
      },
      handleClose() {
        this.innerVisible = false
        this.$emit('update:visible', false)
        this.$emit('close')
      },
      handleConfirm() {
        this.$emit('confirm')
        this.handleClose()
      },
    },
  }
</script>

<style lang="scss">
  .event-activity-dialog {
    border-radius: 16px;
    overflow: visible;

    .el-dialog__header {
      display: none;
      padding: 0;
    }

    .el-dialog__body {
      position: relative;
      padding: 36px 28px 28px;
    }
  }

  .event-activity-dialog__close {
    position: absolute;
    top: -14px;
    right: -14px;
    z-index: 2;
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    color: #909399;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 16px;
      font-weight: bold;
    }

    &:hover {
      color: #606266;
    }
  }

  .event-activity-dialog__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .event-activity-dialog__icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: #fff0e6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    i {
      font-size: 28px;
      color: #ff8a3d;
    }
  }

  .event-activity-dialog__title {
    font-size: 22px;
    font-weight: 700;
    color: #0b1523;
    line-height: 1.3;
    margin-bottom: 12px;
  }

  .event-activity-dialog__date {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex-shrink: 0;
    margin-bottom: 20px;
    color: #909399;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.4;

    i {
      font-size: 18px;
    }
  }

  .event-activity-dialog__scroll {
    width: 100%;
    max-height: 42vh;
    margin-bottom: 16px;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .event-activity-dialog__desc {
    width: 100%;
    box-sizing: border-box;
    padding: 14px 16px;
    margin-bottom: 16px;
    border-radius: 10px;
    background: #eef2ff;
    text-align: left;

    &:last-child {
      margin-bottom: 0;
    }

    p {
      margin: 0;
      color: #3a73ff;
      font-size: 18px;
      line-height: 1.7;
      font-weight: 500;
    }
  }

  .event-activity-dialog__image {
    width: 100%;
    margin-bottom: 8px;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }

    .el-image {
      display: block;
      width: 100%;
    }

    // 宽度撑满，高度随图完整展示；过高时由外层 __scroll 上下滚动
    .el-image__inner {
      display: block;
      width: 100%;
      height: auto;
      object-fit: contain;
    }
  }

  .event-activity-dialog__confirm {
    flex-shrink: 0;
    width: 100%;
    height: 44px;
    padding: 0;
    border: none;
    border-radius: 22px;
    background: #3a73ff;
    font-size: 16px;
    font-weight: 500;

    &:hover,
    &:focus {
      background: #2f62e6;
      border-color: #2f62e6;
    }
  }
</style>
